<template>
  <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" class="icon-vector demo-scroll" viewBox="0 0 60 60">
    <defs>
      <mask :id="uuid + '-up'">
        <polygon points="34.1,14.5 18.7,18.7 14.5,34.1 25.9,45.5 41.3,41.3 45.5,25.9" fill="#000"/>
        <polygon :ref="uuid + '-arrow-up'" points="25.7,26.5 27,27.8 30,24.8 33,27.8 34.3,26.4 30,22.2" fill="#fff"/>
      </mask>
      <mask :id="uuid + '-down'">
        <polygon points="34.1,14.5 18.7,18.7 14.5,34.1 25.9,45.5 41.3,41.3 45.5,25.9" fill="#000"/>
        <polygon :ref="uuid + '-arrow-down'" points="30,35.2 27,32.2 25.7,33.6 30,37.8 34.3,33.5 33,32.2" fill="#fff"/>
      </mask>
    </defs>

    <polygon :ref="uuid + '-hex-outer'"
      points="42,9.2 18,9.2 6,30 18,50.8 42,50.8 54,30"
      stroke-width="3"
      fill="none"
      :stroke="fill"/>

    <polygon :ref="uuid + '-hex-inner'"
      points="34.1,14.5 18.7,18.7 14.5,34.1 25.9,45.5 41.3,41.3 45.5,25.9"
      stroke-width="2"
      fill="none"
      :stroke="fill"
      :opacity="opacity"/>

    <polygon
      points="33.8,15.1 19,19.2 15.2,34.1 26.2,44.9 41,40.8 44.8,25.9"
      :fill="fill"
      :opacity="opacity"
      :mask="'url(#' + uuid + '-up)'"/>

    <polygon
      points="33.8,15.1 19,19.2 15.2,34.1 26.2,44.9 41,40.8 44.8,25.9"
      :fill="fill"
      :mask="'url(#' + uuid + '-down)'"/>
  </svg>
</template>

<script>
import { TimelineMax, TweenMax, Power2 } from 'gsap'

export default {
  name: 'scroll-icon',
  props: {
    complete: {
      type: Boolean,
      default: false
    },
    active: {
      type: Boolean,
      default: false
    },
    isButton: {
      type: Boolean,
      default: false
    },
    white: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      activeTween: undefined,
      tweenTargets: []
    }
  },
  computed: {
    opacity () {
      return this.complete ? 1 : 0.25
    },
    fill () {
      return this.white ? '#fff' : '#1F1F1F'
    }
  },
  watch: {
    active () {
      if ( this.isButton ) {
        if ( this.active ) {
          this.animateIcon()
        } else {
          if ( this.activeTween ) {
            this.activeTween.pause()
            TweenMax.to( [ this.$refs[this.uuid + '-hex-outer'], this.$refs[this.uuid + '-hex-inner'] ], 1, {
              rotation: 0,
              ease: Power2.easeInOut
            } )
            TweenMax.to( [ this.$refs[this.uuid + '-arrow-up'], this.$refs[this.uuid + '-arrow-down'] ], 1, {
              y: 0,
              opacity: 1,
              ease: Power2.easeInOut
            } )
          }
        }
      }
    }
  },
  methods: {
    initTween () {
      this.activeTween = new TimelineMax( { paused: true, repeat: -1, repeatDelay: 0.5 } )
      this.activeTween.add( TweenMax.to( this.$refs[this.uuid + '-hex-inner'], 1, {
        rotation: -60,
        transformOrigin: '50% 50%',
        ease: Power2.easeInOut
      } ) )
      this.activeTween.add( TweenMax.to(
        this.$refs[this.uuid + '-arrow-down'], 0.5, {
          y: 15,
          opacity: 1,
          ease: Power2.easeInOut,
          onComplete: () => {
            TweenMax.set(this.$refs[this.uuid + '-arrow-down'], { opacity: 0, y: -5 })
          }
        }
      ), '-=0.75' )
      this.activeTween.add( TweenMax.to(
        this.$refs[this.uuid + '-arrow-down'], 0.5, {
          y: 0,
          opacity: 1,
          ease: Power2.easeInOut
        }
      ) )
      this.activeTween.add( TweenMax.to(
        this.$refs[this.uuid + '-hex-outer'], 1, {
          delay: 1,
          rotation: 60,
          transformOrigin: '50% 50%',
          ease: Power2.easeInOut
        }
      ), '-=1' )
      this.activeTween.add( TweenMax.to(
        this.$refs[this.uuid + '-arrow-up'], 0.5, {
          y: -15,
          opacity: 1,
          ease: Power2.easeInOut,
          onComplete: () => {
            TweenMax.set(this.$refs[this.uuid + '-arrow-up'], { opacity: 0, y: 5 })
          }
        }
      ), '-=0.75' )
      this.activeTween.add( TweenMax.to(
        this.$refs[this.uuid + '-arrow-up'], 0.5, {
          y: 0,
          opacity: 1,
          ease: Power2.easeInOut
        }
      ) )
      this.tweenTargets.push( this.$refs[this.uuid + '-hex-outer'] )
      this.tweenTargets.push( this.$refs[this.uuid + '-hex-inner'] )
      this.tweenTargets.push( this.$refs[this.uuid + '-arrow-down'] )
      this.tweenTargets.push( this.$refs[this.uuid + '-arrow-up'] )
      this.tweenTargets.push( this.activeTween )
      this.animateIcon()
    },
    animateIcon () {
      if ( this.active && this.activeTween.paused() ) {
        this.activeTween.restart()
      }
    }
  },
  mounted () {
    if ( this.isButton ) {
      this.$nextTick( () => {
        this.initTween()
        // this.$root.$on( 'playActiveIcon', this.animateIcon )
      } )
    }
  },
  beforeDestroy () {
    TweenMax.killTweensOf( this.tweenTargets )
  }
}
</script>



// WEBPACK FOOTER //
// src/components/svg/ScrollIcon.vue